import { Link } from "react-router-dom";
import {
  ChevronRightIcon,
  ChartBarIcon,
  UserPlusIcon,
  CommandLineIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import PageHeader from "../../components/PageHeader/PageHeader";

const AdminDashboard = () => {
  return (
    <>
      <PageHeader backLink="/account" pageTitle="Admin Dashboard" />

      <div className="flex flex-col w-full bg-gray-50/50 min-h-[calc(100vh-63px)]">
        <div className="w-full bg-white border-b border-gray-200">
          <ul className="divide-y divide-gray-200">
            <li>
              <Link
                to="/admin-dashboard/user-metrics"
                className="w-full flex items-center justify-between px-4 py-4 text-sm font-medium text-left text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors"
              >
                <div className="flex items-center">
                  <ChartBarIcon className="mr-3 h-5 w-5 text-gray-500" />
                  User Metrics
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" />
              </Link>
            </li>

            <li>
              <Link
                to="/admin-dashboard/invite-user"
                className="w-full flex items-center justify-between px-4 py-4 text-sm font-medium text-left text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors"
              >
                <div className="flex items-center">
                  <UserPlusIcon className="mr-3 h-5 w-5 text-gray-500" />
                  Invite User To Platform
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" />
              </Link>
            </li>

            <li>
              <Link
                to="/admin-dashboard/custom-endpoint"
                className="w-full flex items-center justify-between px-4 py-4 text-sm font-medium text-left text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors"
              >
                <div className="flex items-center">
                  <CommandLineIcon className="mr-3 h-5 w-5 text-gray-500" />
                  Call Custom Endpoint
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" />
              </Link>
            </li>

            <li>
              <Link
                to="/admin-dashboard/delete-user"
                className="w-full flex items-center justify-between px-4 py-4 text-sm font-medium text-left text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-colors"
              >
                <div className="flex items-center">
                  <TrashIcon className="mr-3 h-5 w-5 text-gray-500" />
                  Delete User
                </div>
                <ChevronRightIcon className="h-5 w-5 text-gray-400" />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
